export default {
  results: [],
  allColumns: [],
  headerColumns: [],
  scannedStatistics: [],
  scannerStatus: true,
  mScanResulsts: [],
  mScanColumns: [],
  mScanColOrder: [],
  isAutoRefresh: false,

  //selected rows
  selectedRows: [], //arrayOF(objects)
  isSelectAllChecked: false,
  approvedRows: [], //arrayOF(objects)
  isAllApproved: false,
  selectedScannerActionData: {}
};
